import React from "react";
import AutoCompleteDropdown from "../../../../widgets/Dropdown/AutoCompleteDropdown";
import { MIN_SEARCH_LENGTH } from "constants/constants";

const BranchSelector = ({
  errors,
  selectedBranch,
  setSelectedBranch,
  setValues,
  fetchSchoolBranches,
}) => {
  const handleBranchChange = (branch) => {
    setSelectedBranch(branch);
    setValues(
      (prev) => ({
        ...prev,
        branch_name: branch?.name || "",
        branch_id: branch?.id || "",
      }),
      true,
    );
  };

  return (
    <AutoCompleteDropdown
      label="Select Branch"
      placeholder="Search branch..."
      value={selectedBranch}
      onChange={handleBranchChange}
      fetchOptions={fetchSchoolBranches}
      getOptionLabel={(option) => option?.name || ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      minSearchLength={MIN_SEARCH_LENGTH}
      fullWidth
      error={!!errors.branch}
      helperText={errors.branch || ""}
    />
  );
};

export default BranchSelector;
